export enum StockOperation {
  Add= 1,
  Remove
}

export enum StockInputMode {
  Form= 1,
  Scan
}

export enum StockUiMode {
  Filter = 1,
  Search = 2
}
